// src/oura/lib/safeRedirect.ts
//
// Where a "connect" button may send the browser. The backend answers a
// connect with the address of Google's consent screen, and the page follows
// it with window.location.assign(). That address is checked first, so a
// malformed or unexpected one fails closed with an error the merchant can
// read, rather than navigating somewhere else (or running a `javascript:`
// URL), or throwing and leaving the button spinning.
//
// Allowed: https on Google's sign-in host, this app's own origin and the
// API's origin (an OAuth start the backend serves itself). Plain http only
// in a dev build, for a local API.

const GOOGLE_ACCOUNTS = "https://accounts.google.com";

/** `raw` as a full URL when it is safe to navigate to, otherwise null. */
export function safeConnectRedirect(raw: string): string | null {
    try {
        const url = new URL(raw, window.location.origin);
        const api = import.meta.env.VITE_TALENT_AI_BE_BASE_URL;
        const allowed = new Set([window.location.origin, GOOGLE_ACCOUNTS]);
        if (api) allowed.add(new URL(api, window.location.origin).origin);
        const protocolOk = url.protocol === "https:" || (import.meta.env.DEV && url.protocol === "http:");
        return protocolOk && allowed.has(url.origin) ? url.href : null;
    } catch {
        return null;
    }
}
